/**
 * Auto-generated Zod schema for Repository
 * DO NOT MODIFY - regenerate with: bun run generate:schemas
 */

import type { Repository as RepositoryOctokit } from '@octokit/webhooks-types';
import { z } from 'zod';

import { LicenseSchema } from './license.js';
import { UserSchema } from './user.js';

export const RepositorySchema = z.object({
  id: z.number(),
  node_id: z.string(),
  name: z.string(),
  full_name: z.string(),
  private: z.boolean(),
  owner: UserSchema,
  html_url: z.string(),
  description: z.string().nullable(),
  fork: z.boolean(),
  url: z.string(),
  forks_url: z.string(),
  keys_url: z.string(),
  collaborators_url: z.string(),
  teams_url: z.string(),
  hooks_url: z.string(),
  issue_events_url: z.string(),
  events_url: z.string(),
  assignees_url: z.string(),
  branches_url: z.string(),
  tags_url: z.string(),
  blobs_url: z.string(),
  git_tags_url: z.string(),
  git_refs_url: z.string(),
  trees_url: z.string(),
  statuses_url: z.string(),
  languages_url: z.string(),
  stargazers_url: z.string(),
  contributors_url: z.string(),
  subscribers_url: z.string(),
  subscription_url: z.string(),
  commits_url: z.string(),
  git_commits_url: z.string(),
  comments_url: z.string(),
  issue_comment_url: z.string(),
  contents_url: z.string(),
  compare_url: z.string(),
  merges_url: z.string(),
  archive_url: z.string(),
  downloads_url: z.string(),
  issues_url: z.string(),
  pulls_url: z.string(),
  milestones_url: z.string(),
  notifications_url: z.string(),
  labels_url: z.string(),
  releases_url: z.string(),
  deployments_url: z.string(),
  created_at: z.union([z.string(), z.number()]),
  updated_at: z.string(),
  pushed_at: z.union([z.string(), z.number()]).nullable(),
  git_url: z.string(),
  ssh_url: z.string(),
  clone_url: z.string(),
  svn_url: z.string(),
  homepage: z.string().nullable(),
  size: z.number(),
  stargazers_count: z.number(),
  watchers_count: z.number(),
  language: z.string().nullable(),
  has_issues: z.boolean(),
  has_projects: z.boolean(),
  has_downloads: z.boolean(),
  has_wiki: z.boolean(),
  has_pages: z.boolean(),
  has_discussions: z.union([z.literal(false), z.literal(true)]).optional(),
  forks_count: z.number(),
  mirror_url: z.string().nullable(),
  archived: z.boolean(),
  disabled: z.union([z.literal(false), z.literal(true)]).optional(),
  open_issues_count: z.number(),
  license: LicenseSchema.nullable(),
  forks: z.number(),
  open_issues: z.number(),
  watchers: z.number(),
  stargazers: z.number().optional(),
  default_branch: z.string(),
  allow_squash_merge: z.union([z.literal(false), z.literal(true)]).optional(),
  allow_merge_commit: z.union([z.literal(false), z.literal(true)]).optional(),
  allow_rebase_merge: z.union([z.literal(false), z.literal(true)]).optional(),
  allow_auto_merge: z.union([z.literal(false), z.literal(true)]).optional(),
  allow_forking: z.union([z.literal(false), z.literal(true)]).optional(),
  allow_update_branch: z.union([z.literal(false), z.literal(true)]).optional(),
  use_squash_pr_title_as_default: z.union([z.literal(false), z.literal(true)]).optional(),
  squash_merge_commit_message: z.string().optional(),
  squash_merge_commit_title: z.string().optional(),
  merge_commit_message: z.string().optional(),
  merge_commit_title: z.string().optional(),
  is_template: z.boolean(),
  web_commit_signoff_required: z.boolean(),
  topics: z.array(z.string()),
  visibility: z.union([z.literal('public'), z.literal('private'), z.literal('internal')]),
  delete_branch_on_merge: z.union([z.literal(false), z.literal(true)]).optional(),
  master_branch: z.string().optional(),
  permissions: z
    .object({
      pull: z.boolean(),
      push: z.boolean(),
      admin: z.boolean(),
      maintain: z.union([z.literal(false), z.literal(true)]).optional(),
      triage: z.union([z.literal(false), z.literal(true)]).optional(),
    })
    .optional(),
  public: z.union([z.literal(false), z.literal(true)]).optional(),
  organization: z.string().optional(),
  custom_properties: z.record(
    z.string(),
    z.union([z.string(), z.array(z.string())]).nullable(),
  ),
}) satisfies z.ZodType<RepositoryOctokit>;

export type Repository = RepositoryOctokit;

export function isRepository(value: unknown): value is Repository {
  return RepositorySchema.safeParse(value).success;
}
